import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors) => ({
  container: {
    height: 8,
    aspectRatio: 6,
    maxWidth: 150,
    borderRadius: theme.borderRadius.full,
    backgroundColor: colors.backgroundL1,
    overflow: 'hidden',
  },
  bar: {
    height: '100%',
    width: '100%',
    backgroundColor: colors.backgroundPrimaryInverse,
    borderRadius: theme.borderRadius.full,
  },
}));
